import React from 'react';

import {
	PANEL_FOOTER_NOTE_ITEM_STYLE,
	PANEL_FOOTER_NOTES_HEADING_STYLE,
	PANEL_FOOTER_NOTES_STYLE,
	PANEL_FOOTER_OUTER_STYLE
} from './blueprint-panel-footer.styles';
import { BlueprintSignoffTable } from './blueprint-signoff-table';
import { EditableText } from './editable-text';

export type BlueprintPanelFooterProps = {
	/** Per-sheet override key prefix from getPageOverrideScope — keeps one page's notes off every other page. */
	scope: string;
	notes?: Array<string>;
	noteScope: string;
};

/**
 * PDF containerSection: display flex, flexDirection row, alignItems stretch, gap 10pt, marginTop 10pt
 * PDF noteContainer: bg #eee, fontSize 10pt, border 1px solid #000, lineHeight 1.5, width 70%, padding 10pt
 *
 * Scaled 1.389x: gap 14px, marginTop 14px, padding 14px. fontSize inherits from wrapper (14px = 10pt).
 */
export const BlueprintPanelFooter = (props: BlueprintPanelFooterProps): React.ReactElement => {
	const { scope, notes = [], noteScope } = props;

	return (
		<div style={PANEL_FOOTER_OUTER_STYLE}>
			{/* Left: Sign-off / Casting Table — 30% width */}
			<BlueprintSignoffTable scope={scope} />

			{/* Right: Additional Notes — matches PDF noteContainer */}
			<div style={PANEL_FOOTER_NOTES_STYLE}>
				<EditableText overrideKey={`panelFooter.${scope}.additionalNotes`} style={PANEL_FOOTER_NOTES_HEADING_STYLE}>
					Additional Notes
				</EditableText>
				{/* Auto-derived standard notes: editable, though edits are overwritten when the design re-derives them. */}
				{notes.length > 0 && (
					<EditableText overrideKey={`panelFooter.${scope}.standardNotes`} mergeStrategy='derived' style={PANEL_FOOTER_NOTE_ITEM_STYLE}>
						{notes.map((note, i) => (
							<React.Fragment key={i}>
								{i > 0 && (note.startsWith('\t') ? <br /> : <><br /><br /></>)}
								{note}
							</React.Fragment>
						))}
					</EditableText>
				)}
				{/* Manual notes: the only sticky part — keyed per panel, surfaced onto the Kitchen Overview NSC list. */}
				<EditableText overrideKey={`panelFooter.notes.${noteScope}`} style={PANEL_FOOTER_NOTE_ITEM_STYLE}>
					<br />
				</EditableText>
			</div>
		</div>
	);
};
